
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sneakers/technology/[technologyValue]",
      function () {
        return require("private-next-pages/sneakers/technology/[technologyValue].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sneakers/technology/[technologyValue]"])
      });
    }
  